import { render, staticRenderFns } from "./AgendaDia.vue?vue&type=template&id=de7d1b60&"
import script from "./AgendaDia.vue?vue&type=script&lang=js&"
export * from "./AgendaDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports